import React from 'react';
import { useLocation } from 'react-router-dom';
import logo from "../../assets/V2/svg/poweredby.svg";

function StoreFooter() {
  return (
    <footer className="ob-footer fs14 neutral-color-500 grid justify-center">
          <div className='content-center g-5'>
              Powered by  <img src={logo} alt='logo'/>
          </div>
    </footer>
  );
}

export default StoreFooter;
